import {Instance, types} from 'mobx-state-tree';

export const NavBarStore = types.model({
  isDockedSider: types.boolean,
}).actions(self => {
  const setIsDockedSider = (value: boolean) => {
    self.isDockedSider = value;
  };

  return {
    setIsDockedSider,
  };
});

export type NavBarStoreType = Instance<typeof NavBarStore>;

export function initNavBarStore() {
  return NavBarStore.create({
    isDockedSider: true,
  });
}
